import React, { useState, useEffect } from "react";
import { Box, Modal } from "@mui/material";
import { useUser } from '../../../context/useUser'

const Advertise = () => {
    const [open, setOpen] = useState(false);
    const { country } = useUser()

    useEffect(() => {
        const hasSeenModal = sessionStorage.getItem("hasSeenModal");
        if (!hasSeenModal) {
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        sessionStorage.setItem("hasSeenModal", "true");
        setOpen(false);
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            BackdropProps={{
                style: {
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                },
            }}
        >
            <Box
                sx={{
                    width: "90%",
                    height: "80%",
                    maxWidth: '500px',
                    maxHeight: '400px',
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: 24,
                    borderRadius: 3,
                    overflow: "hidden",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        color: "#5c4033",
                        padding: 4,
                        textAlign: "center",
                    }}
                >
                    <h1 className="text-white font-[700] text-3xl">Dear Customer!</h1>
                    <h2 className="text-white font-[400] text-xl mt-3">We currently deliver only in <span className="text-white font-[700] text-2xl">{country === "PK" ? 'Lahore"' : '"Pennsylvania (PA)"'}</span> to ensure top-notch freshness!</h2>
                    <br />
                    <h1 className="text-white font-[700] text-3xl">&</h1>
                    <h2 className="text-white font-[400] mb-6 text-xl mt-3">We accept donations all over the <span className="text-white font-[700] text-2xl">"World"</span> Every donation is a step toward a world full of smiles!</h2>
                    <button onClick={handleClose} className="px-8 py-2.5 bg-[#8a2e25] text-[15px] font-[500] text-white rounded-[5px]">GOT IT</button>
                </Box>
            </Box>
        </Modal>
    );
};

export default Advertise;
